

    import { ref } from 'vue';
    import BookRepository from "@/services/BookRepository";
    import BookResult from "@/models/bookresult.models";
    import {Team} from "@/models/team.models";
    import TeamRepository from "@/services/TeamRepository";
    import {useToast} from "primevue/usetoast";
    import NameBook from "@/models/namebook.models";
    import router from "@/router";
    import {useStore} from "vuex";

    export default {
        props: {
            id: Number,
        },
        setup(){
            const phoneNumber = ref("");
            const books = ref([] as BookResult[]);
            const teams = ref({} as Team[]);
            const toast = useToast();
            const name = ref("");
            const listName = ref([] as NameBook[]);
            const date1 = ref(new Date());
            const invalid = ref(true);
            const store = useStore();

            if(store.state.token == ""){
                router.push({
                    name: 'home'
                });
            }

            TeamRepository.getTeams()
                .then((response) => {
                    teams.value = response.data;
                })
                .catch();

            const clear = () => { phoneNumber.value = ""};

            const searchBooksByPhone = () => {
                BookRepository.getBooksByPhone(phoneNumber.value, date1.value[0]/1000, date1.value[1]/1000)
                    .then(response => {
                        books.value = response.data;
                        books.value.forEach(x => {
                            teams.value.forEach(y => {
                                if(y.code == x.team) x.team = y.name;
                            });
                        });
                        books.value.forEach(x => {if(x.doctor == null || x.doctor == "") x.doctor = "Chưa khám bệnh";});
                        if(response.data.length == 0)
                        {
                            toast.add({
                                severity: 'error',
                                summary: 'Thất bại',
                                detail: 'Số điện thoại không tồn tại, vui lòng nhập đúng số điện thoại.',
                                life: 2000
                            });
                        }
                    })
                    .catch(err => {
                        toast.add({
                            severity: 'error',
                            summary: 'Lỗi',
                            detail:"Vui lòng nhập số điện thoại.",
                            life: 2000
                        });
                    })
                    .finally(()=>{
                    });};

            const searchBooksByName = (name) => {
                if(name == null)
                    books.value = [];
                else
                    BookRepository.getBooksByName(name, date1.value[0]/1000, date1.value[1]/1000)
                        .then(response => {
                            books.value = response.data;
                            books.value.forEach(x => {
                                teams.value.forEach(y => {
                                    if(y.code == x.team) x.team = y.name;
                                });
                            });
                            books.value.forEach(x => {if(x.doctor == null || x.doctor == "") x.doctor = "Chưa khám bệnh";});
                            if(response.data.length == 0)
                            {
                                toast.add({
                                    severity: 'error',
                                    summary: 'Thất bại',
                                    detail: 'Tên bệnh nhân không tồn tại, vui lòng nhập lại.',
                                    life: 2000
                                });
                            }
                        })
                        .catch(err => {
                            toast.add({
                                severity: 'error',
                                summary: 'Lỗi',
                                detail:"Vui lòng lại tên bệnh nhân.",
                                life: 2000
                            });
                        })
                        .finally(()=>{
                        });};

            const loadBook = () => {searchBooksByPhone();};

            const searchName = () => {
                searchBooksByName(name.value);
            };

            const selectCalendar = () => {
                if((date1.value[0] != null)&&(date1.value[1] != null)){
                    invalid.value = false;
                    BookRepository.getNames(date1.value[0]/1000, date1.value[1]/1000)
                        .then((response) => {
                            listName.value = response.data;
                    });
                }
            };
            const clearCalendar = () => {
                phoneNumber.value = "";
                books.value = [];
                invalid.value = true;
                name.value = "";
            };

            return {
                searchBooksByPhone,
                phoneNumber,
                books,
                loadBook,
                clear,
                name,
                listName,
                searchName,
                selectCalendar,
                date1,
                invalid,
                clearCalendar,
            }
        }
    }

